export default {
  items: [
    {
      icon: "view_list",
      title: "Commissions",
      feature: "default",
      security: "employee",
      route: "/",
      subMenu: [
        {
          icon: "settings",
          title: "Review",
          route: "/commissions-review"
        },
        {
          icon: "settings",
          title: "View Clawbacks",
          route: "/view-clawbacks"
        },
        {
          icon: "settings",
          title: "Previous Payments",
          route: "/previous-payments"
        },
        {
          icon: "settings",
          title: "Suppress",
          route: "/commissions-suppressed"
        },
        {
          icon: "settings",
          title: "Reports",
          route: "/commisisons-reports"
        },
        {
          icon: "settings",
          title: "Rules",
          route: "/commissions-rules"
        },
        {
          icon: "settings",
          title: "Setup",
          route: "/commissions-setup"
        }
      ]
    },
    {
      icon: "view_list",
      title: "Partners",
      route: "/list-partners",
      feature: "partner",
      security: "admin"
    },
    {
      icon: "airplanemode_active",
      title: "Qantas",
      feature: "default",
      security: "employee",
      route: "/",
      subMenu: [
        {
          icon: "airplanemode_active",
          title: "Qantas Eligible Customers",
          route: "/points-management-report-eligible"
        },
        {
          icon: "airplanemode_active",
          title: "Qantas Paid Customers",
          route: "/points-management-report-paid"
        },
        {
          icon: "airplanemode_active",
          title: "Qantas Transmission",
          route: "/points-management-report-sent"
        },
        {
          icon: "airplanemode_active",
          title: "Manage Points",
          route: "/qantas-manage-points"
        },
        {
          icon: "airplanemode_active",
          title: "Manage Deleted Records",
          route: "/qantas-manage-deleted-records"
        },
        {
          icon: "airplanemode_active",
          title: "Add Manual Points",
          route: "/qantas-add-manual-points"
        }
      ]
    }
  ]
};